import { useNavigate } from 'react-router';
import IfxButton from '../views/common/IfxButton.tsx';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

const NotFound = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'notFound' });
  const navigate = useNavigate();

  const [countdown, setCountdown] = useState(5);

  const navigateHome = () => {
    navigate('/');
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigateHome();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div>
      <div className="not-found">
        <img
          style={{
            alignSelf: 'center',
          }}
          width={240}
          height={240}
          src={`not-found.png`}
          alt="chip image"
        />
        <div className="not-found-title">{t('title')}</div>
        <div className="not-found-subtitle">{t('message')}</div>
        <div className="not-found-redirect-text">{t('message2', { sec: countdown })}</div>
        <IfxButton variant="contained" onClick={navigateHome}>
          {t('back')}
        </IfxButton>
      </div>
    </div>
  );
};

export default NotFound;
